import { match } from "ts-pattern";
import { StyleSchema } from "@makeswift/controls";
import {
  ControlDataTypeKey,
  Types,
  Schema
} from "../prop-controllers";
import { z } from "zod";
const responsiveBorderDataSchema = Schema.responsiveValue(StyleSchema.border);
const borderPropControllerDataV0Schema = responsiveBorderDataSchema;
const BorderPropControllerDataV1Type = "prop-controllers::border::v1";
const borderPropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(BorderPropControllerDataV1Type),
  value: responsiveBorderDataSchema
});
const borderPropControllerDataSchema = z.union([
  borderPropControllerDataV0Schema,
  borderPropControllerDataV1Schema
]);
const BorderPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::border::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers::border::format::responsive-value"
};
function Border(options = {}) {
  return { type: Types.Border, version: 1, options };
}
Border.Format = BorderPropControllerFormat;
function getBorderPropControllerDataResponsiveBorderData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: BorderPropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createBorderPropControllerDataFromResponsiveBorderData(definition, responsiveBorderData) {
  return match(definition).with(
    { version: 1 },
    () => ({
      [ControlDataTypeKey]: BorderPropControllerDataV1Type,
      value: responsiveBorderData
    })
  ).otherwise(() => responsiveBorderData);
}
function getBorderPropControllerDataSwatchIds(data) {
  return getBorderPropControllerDataResponsiveBorderData(data)?.flatMap((override) => override.value).flatMap((borderValue) => {
    return [
      borderValue.borderTop?.color?.swatchId,
      borderValue.borderRight?.color?.swatchId,
      borderValue.borderBottom?.color?.swatchId,
      borderValue.borderLeft?.color?.swatchId
    ].filter(
      (swatchId) => swatchId != null
    );
  }) ?? [];
}
function copyResponsiveBorderData(data, context) {
  return data.map((override) => ({
    ...override,
    value: copyBorderValue(override.value)
  }));
  function copyBorderValue({
    borderTop,
    borderRight,
    borderBottom,
    borderLeft
  }) {
    return {
      borderTop: borderTop && copyBorderSide(borderTop),
      borderRight: borderRight && copyBorderSide(borderRight),
      borderBottom: borderBottom && copyBorderSide(borderBottom),
      borderLeft: borderLeft && copyBorderSide(borderLeft)
    };
  }
  function copyBorderSide(borderSide) {
    const { color } = borderSide;
    if (color == null)
      return borderSide;
    return {
      ...borderSide,
      color: {
        ...color,
        swatchId: context.replacementContext.swatchIds.get(color.swatchId) ?? color.swatchId
      }
    };
  }
}
function copyBorderPropControllerData(data, context) {
  return match(data).with(void 0, () => void 0).with(
    { [ControlDataTypeKey]: BorderPropControllerDataV1Type },
    (v1) => ({
      [ControlDataTypeKey]: BorderPropControllerDataV1Type,
      value: copyResponsiveBorderData(v1.value, context)
    })
  ).otherwise((v0) => copyResponsiveBorderData(v0, context));
}
export {
  Border,
  BorderPropControllerDataV1Type,
  BorderPropControllerFormat,
  borderPropControllerDataSchema,
  copyBorderPropControllerData,
  createBorderPropControllerDataFromResponsiveBorderData,
  getBorderPropControllerDataResponsiveBorderData,
  getBorderPropControllerDataSwatchIds
};
//# sourceMappingURL=border.js.map